// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3yTuS","description":"Xv9rI","app-store":"_26u0W","app-store-link":"V54cB"};